import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function applyCssAsyncClasses(state: "idle" | "pending" | "fulfilled" | "rejected") {
	if (state === "fulfilled") {
		return "bg-green-500 text-white hover:bg-green-600";
	}

	if (state === "rejected") {
		return "bg-red-500 text-white hover:bg-red-600";
	}

	return undefined;
}
